import PDWTracker from "Components/GMS/Pdw/PDWTracker";
import React from "react";
import Dialog from "Components/DesignSystem/Dialog/Dialog";

/**
 * The PDW job log, opened from the Products list's Bulk Action menu. On DS `Dialog`
 * since § 126 — `size="lg"` reproduces the old `width="900px"`, which the log table
 * needs for its four columns.
 */
const LogsPDW = (props) => {
  return (
    <Dialog
      isOpen={!!props.showLogs}
      onClose={props.modalLogsClose}
      closeOnOutsideClick
      size="lg"
      title="PDW Logs"
      data-testid="pdw-products-logs-dialog"
    >
      <PDWTracker />
    </Dialog>
  );
};

export default LogsPDW;
